import { RouteObject } from "react-router-dom";
import { lazyWithReload } from "src/shared/services/lazyWithReload/lazyWithReload";
import RouteProtector from "src/routes/RouteProtector";

const ActiveRegionApplications = lazyWithReload(
  () =>
    import(
      "src/region/features/activeRegionApplications/ActiveRegionApplications"
    ),
);
const ManageRegionApplication = lazyWithReload(
  () => import("src/region/features/manageApplication/ManageRegionApplication"),
);
const Dashboard = lazyWithReload(
  () => import("src/region/features/dashboard/Dashboard"),
);
const ActiveOwnApplications = lazyWithReload(
  () =>
    import("src/region/features/activeOwnApplications/ActiveOwnApplications"),
);
const PastApplications = lazyWithReload(
  () => import("src/region/features/pastApplications/PastApplications"),
);

export const region: RouteObject = {
  path: "/region",
  children: [
    {
      path: "dashboard",
      element: (
        <RouteProtector allowedUsers={["isRegion"]}>
          <Dashboard />
        </RouteProtector>
      ),
    },
    {
      path: "activeOwnApplications",
      element: (
        <RouteProtector allowedUsers={["isRegion"]}>
          <ActiveOwnApplications />
        </RouteProtector>
      ),
    },
    {
      path: "activeRegionApplications",
      element: (
        <RouteProtector allowedUsers={["isRegion"]}>
          <ActiveRegionApplications />
        </RouteProtector>
      ),
    },
    {
      path: "pastOwnApplications",
      element: (
        <RouteProtector allowedUsers={["isRegion"]}>
          <PastApplications />
        </RouteProtector>
      ),
    },
    {
      path: "manageApplication/:id",
      element: (
        <RouteProtector allowedUsers={["isRegion"]}>
          <ManageRegionApplication />
        </RouteProtector>
      ),
    },
  ],
};
